import React from 'react';
import { Link } from 'react-router-dom';
import { frenchFilterConfig } from '../config/french-filter';

export const TestPage: React.FC = () => {
  return (
    <div className="container-custom py-12">
      <h1 className="text-3xl font-bold mb-4">Page de Test</h1>
      <p className="text-gray-600 mb-4">Si vous voyez ce message, React fonctionne correctement !</p>
      
      <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
        <p className="font-bold">✅ React est chargé</p>
        <p>✅ Le routage fonctionne</p>
        <p>✅ Tailwind CSS est actif</p>
      </div>
      
      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-2">Configuration actuelle :</h2>
        <pre className="bg-gray-100 p-4 rounded text-sm">
{`REACT_APP_WORDPRESS_URL: ${process.env.REACT_APP_WORDPRESS_URL || 'Non défini'}
REACT_APP_WC_API_VERSION: ${process.env.REACT_APP_WC_API_VERSION || 'Non défini'}
API Key configurée: ${process.env.REACT_APP_WC_CONSUMER_KEY ? 'Oui' : 'Non'}
Secret configuré: ${process.env.REACT_APP_WC_CONSUMER_SECRET ? 'Oui' : 'Non'}

Filtre français:
- Activé: ${frenchFilterConfig.enabled ? 'Oui' : 'Non'}
- Type: ${frenchFilterConfig.filterType}
- Catégorie: ${frenchFilterConfig.categorySlug || frenchFilterConfig.categoryId || 'Non défini'}`}
        </pre>
      </div>
      
      <div className="mt-8 space-x-4">
        <Link to="/french-filter-config" className="btn-primary">
          Configurer le filtre français
        </Link>
        <Link to="/" className="btn-secondary">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};
